import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import FeatureCard from '../components/FeatureCard';
import TestimonialCard from '../components/TestimonialCard';
import './Home.css';

function Home() {
  const features = []


      return (
    <div className="home-page">
      <HeroSection
        title="Herding Helpers: Connecting Producers in Time of Need"
        subtitle="Herding Helpers connects farmers, ranchers, and emergency services so the right help arrives at the right time."
        buttonText="Find Helpers"
        buttonLink="/search"
        backgroundImage="https://images.unsplash.com/photo-1516467508483-a7212febe31a?ixlib=rb-4.0.             3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
      />
    </div>
  );
}

export default Home;
